import { Text, Code, FormattedDateTime } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { isEmptyString } from '@/utils/string';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'goal' }> };

export function GoalPreview({ result }: Props) {
  const goalEvent = result.other.goal_event;

  return (
    <>
      <MetadataRow label="ID">
        <Code size="xs">{result.other.id}</Code>
      </MetadataRow>
      {!isEmptyString(goalEvent) ? (
        <MetadataRow label="Event">
          <Code size="xs" className="fs-mask">
            {goalEvent}
          </Code>
        </MetadataRow>
      ) : null}
      <MetadataRow label="Created">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.created_at} format="medium" />
        </Text>
      </MetadataRow>
      <MetadataRow label="Updated">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.updated_at} format="medium" />
        </Text>
      </MetadataRow>
    </>
  );
}
